import React from 'react'

export default function JokerOneDay() {
  return (
    <div className="center-main-container casino-page">
    <div className="center-container">
      <div className="casino-page-container teenpatti-joker1">
        <div className="casino-header">
          <span className="casino-name">
            Unlimited Joker Oneday
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>168250425211417</span>
            </small>
          </span>
        </div>
        <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>168250425211417</span>
            </span>
          </div>
        </div>
        <div className="">
          <div className="casino-video">
            <div className="video-box-container">
              <div className="casino-video-box">
                {/* <iframe src="/mediaplayer/joker1/e0bdd226-22b6-4635-a911-c9c81c4ea6b9?ip=122.160.119.41" /> */}
              </div>
            </div>
            <div className="joker-card">
              <h4 className="text-playerb">Joker</h4>
              <span>
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/14.png" />
              </span>
            </div>
            <div className="casino-video-cards">
              <div className="mt-1">
                <h5>Player A</h5>
                <div className="flip-card-container">
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-1">
                <h5>Player B</h5>
                <div className="flip-card-container">
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
          </div>
          <div className="casino-detail">
            <div className="casino-table">
              <div className="casino-table-box">
                <div className="joker1-box">
                  <div className="joker1-other-cards">
                    <h4>Select your Joker</h4>
                    <div>
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/1.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/2.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/3.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/4.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/5.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/6.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/7.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/8.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/9.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/10.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/11.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/12.png"
                      />
                      <img
                        className=""
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/joker1/13.png"
                      />
                    </div>
                  </div>
                </div>
                <div className="casino-table-left-box">
                  <div className="casino-table-row">
                    <div className="casino-nation-detail">
                      <div className="casino-nation-name">Player A</div>
                    </div>
                    <div className="casino-odds-box back">
                      <span className="casino-odds">1.98</span>
                    </div>
                    <div className="casino-odds-box lay">
                      <span className="casino-odds">0</span>
                    </div>
                  </div>
                </div>
                <div className="casino-table-left-box">
                  <div className="casino-table-row">
                    <div className="casino-nation-detail">
                      <div className="casino-nation-name">Player B</div>
                    </div>
                    <div className="casino-odds-box back">
                      <span className="casino-odds">1.98</span>
                    </div>
                    <div className="casino-odds-box lay">
                      <span className="casino-odds">0</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/joker1">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
            </div>
          </div>
        </div>
        <div className="d-none">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div>
    <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  
  
  )
}
